import React, { Component, createRef } from "react";
import { Grid, Box, Typography } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
// import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchCompany, apiURL } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import PH_LOGO from "../images/PHLogo.png";
import PH_LETTERPADIMG from "../images/PHLetterPadImg.png";
import PH_Signature from "../images/PHSignature.png";
import PH_Stamp from "../images/PHStamp.png";
import ImageUploadIcon from "./CustomTool/ImageUploadIcon";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtTextFieldPWD from "./CustomTool/CtTxtPWD";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtTxtNum from "./CustomTool/CtTxtNum";
import GstInfo from "./GstInfo";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import CtART from "./CustomTool/ResponsiveTable";
import CtTxtPWD from "./CustomTool/CtTxtPWD";

class CompanyMaster extends Component {
  state = {
    showVerifyDialog: false,
    verifyingAcid: null,
    State: [],
    Branch: [],
    TaxPayerType: [],
    GstRegtrationType: [
      { Type: "Regular" },
      { Type: "Composition" },
      { Type: "N/A" },
    ],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_acid", label: "Ac ID", hide: true },
      { id: "int_defaultcompany", label: "int_defaultcompany", hide: true },
      { id: "vac_company", label: "Trade Name", minWidth: "10" },
      { id: "vac_gstno", label: "GST No" },
      { id: "vac_gstuserid", label: "GST User Id" },
      { id: "vac_gstpassword", label: "Password", hide: true },
      { id: "vac_personname", label: "Legal Name of Business" },
      { id: "vac_address", label: "Address", minWidth: "15" },
      { id: "vac_state", label: "State" },
      { id: "vac_statecode", label: "State Code" },
      { id: "vac_pincode", label: "Pin Code" },
      { id: "vac_gstregtype", label: "Tax Payer Type" },
      { id: "vac_panno", label: "PAN No" },
      { id: "vac_bankname", label: "Bank Name" },
      { id: "vac_bankbranchname", label: "Branch Name" },
      { id: "vac_bankacno", label: "Ac No." },
      { id: "vac_bankifsccode", label: "IFSC" },
      { id: "vac_mobileno", label: "Mobile No" },
      { id: "vac_email", label: "Email ID" },
      { id: "int_defaultcompany", label: "Default Company" },
      { id: "vac_tc1", label: "Terms & Conditions 1" },
      { id: "vac_tc2", label: "Terms & Conditions 2" },
      { id: "vac_tc3", label: "Terms & Conditions 3" },
      { id: "vac_tc4", label: "Terms & Conditions 4" },
      { id: "vac_tc5", label: "Terms & Conditions 5" },
      { id: "vac_einvoiceuserid", label: "E-Invoice User ID" },
      { id: "vac_einvoicepassword", label: "E-Invoice Password" },
      { id: "bint_ci", label: "bint_ci", hide: "true" },
      { id: "vac_ewaybilluserid", label: "E-Way Bill User ID" },
      { id: "vac_ewaybillpassword", label: "E-Way Bill Password" },
      { id: "vac_city", label: "City" },
    ],
    columnsdata: [
      { accessorKey: "bint_acid", header: "Ac ID", hide: true },
      { accessorKey: "bint_salessrno", header: "bint_salessrno" },
      { accessorKey: "vac_image", header: "vac_image" },
      { accessorKey: "vac_logo", header: "vac_logo" },
      { accessorKey: "vac_letterheadname", header: "vac_letterheadname" },
      { accessorKey: "vac_logoname", header: "vac_logoname" },
      {
        accessorKey: "vac_signatureimagename",
        header: "vac_signatureimagename",
      },
      { accessorKey: "vac_signatureimage", header: "vac_signatureimage" },
      { accessorKey: "vac_stamp", header: "vac_stamp" },
      { accessorKey: "vac_stampname", header: "vac_stampname" },
      {
        accessorKey: "int_defaultcompany",
        header: "int_defaultcompany",
        hide: true,
      },
      { accessorKey: "vac_company", header: "Trade Name", minWidth: "10" },
      {
        accessorKey: "vac_gstno",
        header: "GST No",
      },
      { accessorKey: "vac_gstuserid", header: "GST User Id" },
      { accessorKey: "vac_gstpassword", header: "Password", hide: true },
      { accessorKey: "vac_personname", header: "Legal Name of Business" },
      { accessorKey: "vac_address", header: "Address", minWidth: "15" },
      { accessorKey: "vac_state", header: "State" },
      {
        accessorKey: "vac_statecode",
        header: "State Code",
        enableColumnActions: false,
        enableSorting: false,
        size: 110,
      },
      {
        accessorKey: "vac_pincode",
        header: "Pin Code",
        enableColumnActions: false,
        enableSorting: false,
        size: 90,
      },
      { accessorKey: "vac_gstregtype", header: "Tax Payer Type" },
      { accessorKey: "vac_panno", header: "PAN No" },
      { accessorKey: "vac_bankname", header: "Bank Name" },
      { accessorKey: "vac_bankbranchname", header: "Branch Name" },
      { accessorKey: "vac_bankacno", header: "Ac No." },
      {
        accessorKey: "vac_bankifsccode",
        header: "IFSC",
        enableColumnActions: false,
        enableSorting: false,
        size: 90,
      },
      {
        accessorKey: "vac_mobileno",
        header: "Mobile No",
        enableColumnActions: false,
        enableSorting: false,
        size: 100,
      },
      { accessorKey: "vac_email", header: "Email ID" },
      { accessorKey: "int_defaultcompany", header: "Default Company" },
      { accessorKey: "vac_tc1", header: "Terms & Conditions 1" },
      { accessorKey: "vac_tc2", header: "Terms & Conditions 2" },
      { accessorKey: "vac_tc3", header: "Terms & Conditions 3" },
      { accessorKey: "vac_tc4", header: "Terms & Conditions 4" },
      { accessorKey: "vac_tc5", header: "Terms & Conditions 5" },
      {
        accessorKey: "vac_einvoiceuserid",
        header: "E-Invoice User ID",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_einvoicepassword",
        header: "E-Invoice Password",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      { accessorKey: "bint_ci", header: "bint_ci", hide: "true" },
      {
        accessorKey: "vac_ewaybilluserid",
        header: "E-Way Bill User ID",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_ewaybillpassword",
        header: "E-Way Bill Password",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      { accessorKey: "vac_city", header: "City" },
    ],

    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: [
      "bint_acid", // 0
      "vac_gstno", // 1
      "vac_gstuserid", // 2
      "vac_gstpassword", // 3
      "vac_company", // 4
      "vac_personname", //5
      "vac_address", // 6
      "vac_state", // 7
      "vac_statecode", // 8
      "vac_gstregtype", //9
      "vac_panno", // 10
      "int_defaultcompany", // 11
      "vac_mobileno", // 12
      "vac_email", // 13
      "vac_tc1", // 14
      "vac_tc2", // 15
      "vac_tc3", // 16
      "vac_tc4", // 17
      "vac_tc5", // 18
      "vac_bankname", //19
      "vac_bankbranchname", //20
      "vac_bankacno", //21
      "vac_bankifsccode", //22
      "vac_image", //23
      "vac_logo", //24
      "vac_letterheadname", //25
      "vac_logoname", //26
      "bint_ci", //27
      "vac_pincode", //28
      "vac_einvoiceuserid", //29
      "vac_einvoicepassword", //30
      "vac_ewaybilluserid", //31
      "vac_ewaybillpassword", //32
      "vac_signatureimage", //33
      "vac_signatureimagename", //34
      "vac_stamp", //35
      "vac_stampname", //36
      "vac_city", //37
    ],
    formData: {
      bint_acid: "",
      txtCompanyName: "",
      txtMobileNo: "",
      txtEmailId: "",
      txtPersonName: "",
      txtAddress: "",
      txtPANNo: "",
      chkDefaultCompany: false,
      txtGSTNo: "",
      txtGSTUserId: "",
      txtGSTPassword: "",
      txtCity: "",
      cmbState: "Gujarat",
      cmbGstRegtrationType: "",
      txtStateCode: "24",
      txtPinCode: "",
      txtTermsAndConditionLine1: "",
      txtTermsAndConditionLine2: "",
      txtTermsAndConditionLine3: "",
      txtTermsAndConditionLine4: "",
      txtTermsAndConditionLine5: "",
      txtEInvoiceID: "",
      txtEInvoicePassword: "",
      Logo: "",
      LogoLocation: "",
      LogoPath: "",
      LetterPadImg: "",
      LetterPadImgLocation: "",
      LetterPadImgPath: "",
      SignatureImg: "",
      SignatureImgLocation: "",
      SignatureImgPath: "",
      StampImg: "",
      StampImgLocation: "",
      StampImgPath: "",
      txtBankName: "",
      txtBankBranchName: "",
      txtBankAcNo: "",
      txtBankIFSCcode: "",
      bint_ci: "",
      txtEWayBillUserID: "",
      txtEWayBillPassword: "",
      txtUserId: "",
      txtPassword: "",
    },
    searchData: {
      vac_company: "",
      vac_gstno: "",
      vac_gstuserid: "",
      vac_address: "",
      vac_state: "",
      vac_statecode: "",
      vac_gstregtype: "",
      vac_panno: "",
      vac_mobileno: "",
      vac_email: "",
      int_defaultcompany: "",
      vac_tc1: "",
      vac_tc2: "",
      vac_tc3: "",
      vac_tc4: "",
      vac_tc5: "",
      vac_bankname: "",
      vac_bankbranchname: "",
      vac_bankacno: "",
      vac_bankifsccode: "",
      vac_pincode: "",
      vac_einvoiceuserid: "",
      vac_einvoicepassword: "",
      vac_ewaybilluserid: "",
      vac_ewaybillpassword: "",
      vac_city: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    removeKeyboardShortCuts: null,
  };

  constructor(props) {
    super(props);
    this.Logo = createRef();
    this.LetterPadImg = createRef();
    this.Signature = createRef();
    this.Stamp = createRef();
  }

  //#region Component
  componentDidMount() {
    document.title = "RA : Company";
    this.props.setActiveMenu("CompanyMaster");
    this.ShortCut();
    // this.getInfo();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges,
    );
    this.setSearchColumns();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveCompanyDetail,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.onDeleteClick,
      },

      // this.saveSales(true)
    );
  };
  componentWillUnmount() {
    this.removeShortCut();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "txtGSTNo") {
          let Gstno = this.state.formData.txtGSTNo.substring(2, 12);
          this.setState({
            formData: { ...this.state.formData, txtPANNo: Gstno },
          });
        } else if (e.target.name === "cmbState") {
          let txtStateCode = this.state.formData.txtStateCode;
          this.state.State.map((curState) => {
            if (e.target.value === curState.vac_state) {
              txtStateCode = curState.vac_statecode;
            }
          });
          this.setState({
            formData: { ...this.state.formData, txtStateCode },
          });
        }
      },
    );
  };

  handleOnChkChange = (e) => {
    // console.log("e.target", e.target.name);
    // console.log("e.target", e.target.checked);
    if (
      (e.target.name == "" && this.state.rowsCount <= 1 && e.target.checked) ||
      this.state.rowsCount > 1
    ) {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [e.target.name]: e.target.checked,
          },
        },
        () => {
          // console.log(
          //   "this.state.formData.chkDefaultCompany after change",
          //   this.state.formData.chkDefaultCompany
          // );
        },
      );
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    console.log("row", row);

    let bint_acid = row.bint_acid,
      txtGSTNo = row.vac_gstno,
      txtGSTUserId = row.vac_gstuserid,
      txtGSTPassword = row.vac_gstpassword,
      txtCompanyName = row.vac_company,
      txtPersonName = row.vac_personname,
      txtAddress = row.vac_address,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      cmbGstRegtrationType = row.vac_gstregtype,
      txtPANNo = row.vac_panno,
      chkDefaultCompany = row.int_defaultcompany,
      txtMobileNo = row.vac_mobileno,
      txtEmailId = row.vac_email,
      txtTermsAndConditionLine1 = row.vac_tc1,
      txtTermsAndConditionLine2 = row.vac_tc2,
      txtTermsAndConditionLine3 = row.vac_tc3,
      txtTermsAndConditionLine4 = row.vac_tc4,
      txtTermsAndConditionLine5 = row.vac_tc5,
      actionName = row.actionName,
      txtBankName = row.vac_bankname,
      txtBankBranchName = row.vac_bankbranchname,
      txtBankAcNo = row.vac_bankacno,
      txtBankIFSCcode = row.vac_bankifsccode,
      vac_image = row.vac_image,
      vac_logo = row.vac_logo,
      vac_letterheadname = row.vac_letterheadname,
      vac_logoname = row.vac_logoname,
      bint_ci = row.bint_ci,
      txtPinCode = row.vac_pincode,
      txtEInvoiceID = row.vac_einvoiceuserid,
      txtEInvoicePassword = row.vac_einvoicepassword,
      txtEWayBillUserID = row.vac_ewaybilluserid,
      txtEWayBillPassword = row.vac_ewaybillpassword,
      vac_signatureimagename = row.vac_signatureimagename,
      vac_signatureimage = row.vac_signatureimage,
      vac_stamp = row.vac_stamp,
      vac_stampname = row.vac_stampname,
      txtCity = row.vac_city;
    if (actionName === "Edit") {
      let LogoPath = vac_logo != "" ? apiURL + vac_logo : PH_LOGO;
      let LetterPadImgPath =
        vac_image != "" ? apiURL + vac_image : PH_LETTERPADIMG;
      let SignatureImgPath =
        vac_signatureimage != "" ? apiURL + vac_signatureimage : PH_Signature;
      let StampImgPath = vac_stamp != "" ? apiURL + vac_stamp : PH_Stamp;

      this.setState(
        {
          formData: {
            ...this.state.formData,
            bint_acid,
            txtCompanyName,
            txtMobileNo,
            txtEmailId,
            txtPersonName,
            txtAddress,
            txtPANNo,
            txtGSTNo,
            txtGSTUserId,
            txtGSTPassword,
            cmbState,
            txtStateCode,
            txtPinCode,
            cmbGstRegtrationType,
            chkDefaultCompany,
            txtTermsAndConditionLine1,
            txtTermsAndConditionLine2,
            txtTermsAndConditionLine3,
            txtTermsAndConditionLine4,
            txtTermsAndConditionLine5,
            txtEInvoiceID,
            txtEInvoicePassword,
            txtBankName,
            txtBankBranchName,
            txtBankAcNo,
            txtBankIFSCcode,
            Logo: vac_logoname,
            LogoLocation: LogoPath,
            LogoPath,
            LetterPadImg: vac_letterheadname,
            LetterPadImgLocation: LetterPadImgPath,
            LetterPadImgPath,
            bint_ci,
            txtEWayBillUserID,
            txtEWayBillPassword,
            SignatureImg: vac_signatureimagename,
            SignatureImgLocation: SignatureImgPath,
            SignatureImgPath,
            StampImg: vac_stampname,
            StampImgLocation: StampImgPath,
            StampImgPath,
            txtCity,
          },
        },
        () => {
          // console.log("this.state.formData", this.state.formData);
        },
      );
      document.getElementById("txtGSTNo").focus();
    } else if (actionName === "Delete") {
      // console.log("bint_acid", bint_acid);
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Company : " + txtCompanyName + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteCompanyDetail(bint_acid);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_acid !== bint_acid &&
          row.vac_companyname !== txtCompanyName &&
          row.vac_mobileno !== txtMobileNo &&
          row.vac_email !== txtEmailId &&
          row.vac_address !== txtAddress &&
          row.vac_panno !== txtPANNo &&
          row.vac_gstno !== txtGSTNo &&
          row.vac_state !== cmbState &&
          row.vac_statecode !== txtStateCode &&
          row.vac_gstregtype !== cmbGstRegtrationType &&
          row.vac_tc1 !== txtTermsAndConditionLine1 &&
          row.vac_tc2 !== txtTermsAndConditionLine2 &&
          row.vac_tc3 !== txtTermsAndConditionLine3 &&
          row.vac_tc4 !== txtTermsAndConditionLine4 &&
          row.vac_tc5 !== txtTermsAndConditionLine5
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_acid", "vac_company"]);

    const bint_acid = row.bint_acid,
      txtCompanyName = row.vac_company;

    let Msg = () => {
      return (
        <>
          <p>Do you want to Delete Company : {txtCompanyName}</p>
          <p
            style={{
              color: "red",
              fontSize: "17px",
              fontWeight: "bold",
              marginTop: "0px",
              paddingTop: "0px",
            }}
          >
            Note:- This deletion process will remove all data of the Company,
            and this can not be undo at any conditions
          </p>
        </>
      );
    };
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDelete="Delete"
          labelDisagree="Cancel"
          DisagreeBtnVariant="outlined"
          // alertTitle={Msg()}
          alertNote="This deletion process will remove all data of the Company, and this can not be undo at any conditions"
          alertTitle={`Do you want to Delete Company : ${txtCompanyName}`}
          handleOnClickYes={() => {
            return this.DeleteCompanyDetail(bint_acid);
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "bint_salessrno",
      "vac_gstno",
      "vac_gstuserid",
      "vac_gstpassword",
      "vac_company",
      "vac_personname",
      "vac_address",
      "vac_state",
      "vac_statecode",
      "vac_gstregtype",
      "vac_panno",
      "int_defaultcompany",
      "vac_mobileno",
      "vac_email",
      "vac_tc1",
      "vac_tc2",
      "vac_tc3",
      "vac_tc4",
      "vac_tc5",
      "vac_bankname",
      "vac_bankbranchname",
      "vac_bankacno",
      "vac_bankifsccode",
      "vac_image",
      "vac_logo",
      "vac_letterheadname",
      "vac_logoname",
      "bint_ci",
      "vac_pincode",
      "vac_einvoiceuserid",
      "vac_einvoicepassword",
      "vac_ewaybilluserid",
      "vac_ewaybillpassword",
      "vac_signatureimagename",
      "vac_signatureimage",
      "vac_stamp",
      "vac_stampname",
      "vac_city",
    ]);
    let bint_acid = row.bint_acid,
      txtGSTNo = row.vac_gstno,
      txtGSTUserId = row.vac_gstuserid,
      txtGSTPassword = row.vac_gstpassword,
      txtCompanyName = row.vac_company,
      txtPersonName = row.vac_personname,
      txtAddress = row.vac_address,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      cmbGstRegtrationType = row.vac_gstregtype,
      txtPANNo = row.vac_panno,
      chkDefaultCompany = row.int_defaultcompany,
      txtMobileNo = row.vac_mobileno,
      txtEmailId = row.vac_email,
      txtTermsAndConditionLine1 = row.vac_tc1,
      txtTermsAndConditionLine2 = row.vac_tc2,
      txtTermsAndConditionLine3 = row.vac_tc3,
      txtTermsAndConditionLine4 = row.vac_tc4,
      txtTermsAndConditionLine5 = row.vac_tc5,
      txtBankName = row.vac_bankname,
      txtBankBranchName = row.vac_bankbranchname,
      txtBankAcNo = row.vac_bankacno,
      txtBankIFSCcode = row.vac_bankifsccode,
      vac_image = row.vac_image,
      vac_logo = row.vac_logo,
      vac_letterheadname = row.vac_letterheadname,
      vac_logoname = row.vac_logoname,
      bint_ci = row.bint_ci,
      txtPinCode = row.vac_pincode,
      txtEInvoiceID = row.vac_einvoiceuserid,
      txtEInvoicePassword = row.vac_einvoicepassword,
      txtEWayBillUserID = row.vac_ewaybilluserid,
      txtEWayBillPassword = row.vac_ewaybillpassword,
      vac_signatureimagename = row.vac_signatureimagename,
      vac_signatureimage = row.vac_signatureimage,
      vac_stamp = row.vac_stamp,
      vac_stampname = row.vac_stampname,
      txtCity = row.vac_city;

    let LogoPath = vac_logo != "" ? apiURL + vac_logo : PH_LOGO;
    let LetterPadImgPath =
      vac_image != "" ? apiURL + vac_image : PH_LETTERPADIMG;
    let SignatureImgPath =
      vac_signatureimage != "" ? apiURL + vac_signatureimage : PH_Signature;
    let StampImgPath = vac_stamp != "" ? apiURL + vac_stamp : PH_Stamp;

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_acid,
          txtCompanyName,
          txtMobileNo,
          txtEmailId,
          txtPersonName,
          txtAddress,
          txtPANNo,
          txtGSTNo,
          txtGSTUserId,
          txtGSTPassword,
          cmbState,
          txtStateCode,
          txtPinCode,
          cmbGstRegtrationType,
          chkDefaultCompany,
          txtTermsAndConditionLine1,
          txtTermsAndConditionLine2,
          txtTermsAndConditionLine3,
          txtTermsAndConditionLine4,
          txtTermsAndConditionLine5,
          txtEInvoiceID,
          txtEInvoicePassword,
          txtBankName,
          txtBankBranchName,
          txtBankAcNo,
          txtBankIFSCcode,
          Logo: vac_logoname,
          LogoLocation: LogoPath,
          LogoPath,
          LetterPadImg: vac_letterheadname,
          LetterPadImgLocation: LetterPadImgPath,
          LetterPadImgPath,
          bint_ci,
          txtEWayBillUserID,
          txtEWayBillPassword,
          SignatureImg: vac_signatureimagename,
          SignatureImgLocation: SignatureImgPath,
          SignatureImgPath,
          StampImg: vac_stampname,
          StampImgLocation: StampImgPath,
          StampImgPath,
          txtCity,
        },
      },
      () => {
        // console.log("this.state.formData", this.state.formData);
      },
    );
    document.getElementById("txtGSTNo").focus();
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      },
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_company.length === 0 ||
            (row["vac_company"] &&
              row["vac_company"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_company.toLowerCase()))) &&
          (this.state.searchData.vac_gstno.length === 0 ||
            (row["vac_gstno"] &&
              row["vac_gstno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_gstno.toLowerCase()))) &&
          (this.state.searchData.vac_gstuserid.length === 0 ||
            (row["vac_gstuserid"] &&
              row["vac_gstuserid"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_gstuserid.toLowerCase(),
                ))) &&
          (this.state.searchData.vac_address.length === 0 ||
            (row["vac_address"] &&
              row["vac_address"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_address.toLowerCase()))) &&
          (this.state.searchData.vac_state === "" ||
            (row["vac_state"] &&
              row["vac_state"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_state.toLowerCase()))) &&
          (this.state.searchData.vac_statecode.length === 0 ||
            (row["vac_statecode"] &&
              row["vac_statecode"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_statecode.toLowerCase(),
                ))) &&
          (this.state.searchData.vac_gstregtype === "" ||
            (row["vac_gstregtype"] &&
              row["vac_gstregtype"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_gstregtype.toLowerCase(),
                ))) &&
          (this.state.searchData.vac_panno.length === 0 ||
            (row["vac_panno"] &&
              row["vac_panno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_panno.toLowerCase()))) &&
          (this.state.searchData.vac_mobileno.length === 0 ||
            (row["vac_mobileno"] &&
              row["vac_mobileno"]
                .toString()
                .includes(this.state.searchData.vac_mobileno))) &&
          (this.state.searchData.vac_email.length === 0 ||
            (row["vac_email"] &&
              row["vac_email"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email.toLowerCase()))) &&
          (this.state.searchData.vac_pincode.length === 0 ||
            (row["vac_pincode"] &&
              row["vac_pincode"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_pincode.toLowerCase()))) &&
          (this.state.searchData.vac_einvoiceuserid.length === 0 ||
            (row["vac_einvoiceuserid"] &&
              row["vac_einvoiceuserid"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_einvoiceuserid.toLowerCase(),
                ))) &&
          (this.state.searchData.vac_einvoicepassword.length === 0 ||
            (row["vac_einvoicepassword"] &&
              row["vac_einvoicepassword"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_einvoicepassword.toLowerCase(),
                ))) &&
          (this.state.searchData.vac_tc1.length === 0 ||
            (row["vac_tc1"] &&
              row["vac_tc1"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_tc1.toLowerCase()))) &&
          (this.state.searchData.vac_tc2.length === 0 ||
            (row["vac_tc2"] &&
              row["vac_tc2"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_tc2.toLowerCase()))) &&
          (this.state.searchData.vac_tc3.length === 0 ||
            (row["vac_tc3"] &&
              row["vac_tc3"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_tc3.toLowerCase()))) &&
          (this.state.searchData.vac_tc4.length === 0 ||
            (row["vac_tc4"] &&
              row["vac_tc4"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_tc4.toLowerCase()))) &&
          (this.state.searchData.vac_tc5.length === 0 ||
            (row["vac_tc5"] &&
              row["vac_tc5"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_tc5.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState({
        searchOpen,
        searchRows,
        searchRowsCount,
        counter: this.state.counter + 1,
      });
    } else {
      this.setState({ searchOpen });
    }
  };

  //#endregion handle

  //#region function
  // ShortCut = () => {
  //   this.removeShortCut = setKeyboardShortcuts(
  //     this.SaveCompanyDetail,
  //     this.clearInfo,
  //     () => {
  //       this.onDeleteClick();
  //     }
  //     // this.saveSales(true)
  //   );
  // };

  handleOnClickYesRemoveLogoImage = () => {
    let result = this.uploadCompanyPhotos("", "Logo", this.state.formData.Logo);
    return result;
  };

  handleOnClickYesRemoveLetterHeadImage = () => {
    let result = this.uploadCompanyPhotos(
      "",
      "LetterPadImg",
      this.state.formData.LetterPadImg,
    );
    return result;
  };

  handleOnClickYesRemoveSignatureImage = () => {
    let result = this.uploadCompanyPhotos(
      "",
      "Signature",
      this.state.formData.SignatureImg,
    );
    return result;
  };

  handleOnClickYesRemoveStampImage = () => {
    let result = this.uploadCompanyPhotos(
      "",
      "Stamp",
      this.state.formData.StampImg,
    );
    return result;
  };

  onLogoChange = (Logo, LogoLocation, LogoPath) => {
    this.setState(
      {
        formData: { ...this.state.formData, Logo, LogoLocation, LogoPath },
      },
      () => {
        let path = this.state.formData.LogoLocation + this.state.formData.Logo,
          infoType = "Logo";
        // console.log("path", path);
        this.uploadCompanyPhotos(path, infoType);
      },
    );
  };

  onLetterPadChange = (
    LetterPadImg,
    LetterPadImgLocation,
    LetterPadImgPath,
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          LetterPadImg,
          LetterPadImgLocation,
          LetterPadImgPath,
        },
      },
      () => {
        // alert("onLetterPadChange");
        let path =
            this.state.formData.LetterPadImgLocation +
            this.state.formData.LetterPadImg,
          infoType = "LetterPadImg";
        this.uploadCompanyPhotos(path, infoType);
      },
    );
  };

  onSignatureChange = (
    SignatureImg,
    SignatureImgLocation,
    SignatureImgPath,
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          SignatureImg,
          SignatureImgLocation,
          SignatureImgPath,
        },
      },
      () => {
        // alert("onSignatureChange");
        let path =
            this.state.formData.SignatureImgLocation +
            this.state.formData.SignatureImg,
          infoType = "Signature";
        this.uploadCompanyPhotos(path, infoType);
      },
    );
  };

  onStampChange = (StampImg, StampImgLocation, StampImgPath) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          StampImg,
          StampImgLocation,
          StampImgPath,
        },
      },
      () => {
        // alert("onStampChange");
        let path =
            this.state.formData.StampImgLocation + this.state.formData.StampImg,
          infoType = "Stamp";
        this.uploadCompanyPhotos(path, infoType);
      },
    );
  };

  uploadCompanyPhotos = (photopath, InfoType, unlink = "") => {
    // console.log("this.state.fromData", this.state.formData);
    // alert("uploadCompanyPhotos");
    // if (this.validateCompanyDetail()) {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      let reqData = {
        Op: "UploadCompanyPhotos",
        InfoType,
        FilePath: photopath,
        bint_acid: this.state.formData.bint_acid,
        Unlink: unlink,
      };
      fetchCompany(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState(
              {
                dataLoadStatus: true,
              },
              () => {
                if (photopath == "" && InfoType == "Logo") {
                  this.Logo.current.removeImage();
                } else if (photopath == "" && InfoType == "LetterPadImg") {
                  this.LetterPadImg.current.removeImage();
                } else if (photopath == "" && InfoType == "Signature") {
                  this.Signature.current.removeImage();
                } else if (photopath == "" && InfoType == "Stamp") {
                  this.Stamp.current.removeImage();
                }
                return true;
              },
            );
          }
        })
        .catch((error) => {
          this.props.toastMsg(
            "error",
            "Unkonwn Error occured in save company. " + error,
          );
        });
    });
    // }
  };

  removeLogo = () => {
    let ARD = null;
    this.setState(
      {
        ARD,
      },
      () => {
        this.handleOnClickYesRemoveLogoImage();
        // let ARD = <AlertResponsiveDialog
        //   labelAgree='Delete'
        //   labelDisagree='Cancel'
        //   alertTitle={'Do you want to Delete Logo?'}
        //   // alertMessage={ }
        //   handleOnClickYes={() => {
        //     return this.handleOnClickYesRemoveLogoImage()
        //   }}
        //   defaultOpenDialog={true}
        //   onYesClickCloseIfExeSuccessfully={true}
        // />
        this.setState({ ARD });
      },
    );
  };

  removeLetterHead = () => {
    let ARD = null;
    this.setState(
      {
        ARD,
      },
      () => {
        this.handleOnClickYesRemoveLetterHeadImage();
        // let ARD = <AlertResponsiveDialog
        //   labelAgree='Delete'
        //   labelDisagree='Cancel'
        //   alertTitle={'Do you want to Delete Letterhead?'}
        //   // alertMessage={ }
        //   handleOnClickYes={() => {
        //     return this.handleOnClickYesRemoveLetterHeadImage()
        //   }}
        //   defaultOpenDialog={true}
        //   onYesClickCloseIfExeSuccessfully={true}
        // />
        // this.setState({ ARD })
      },
    );
  };

  removeSignature = () => {
    let ARD = null;
    this.setState(
      {
        ARD,
      },
      () => {
        this.handleOnClickYesRemoveSignatureImage();
      },
    );
  };

  removeStamp = () => {
    let ARD = null;
    this.setState(
      {
        ARD,
      },
      () => {
        this.handleOnClickYesRemoveStampImage();
      },
    );
  };

  validateGstInfo = () => {
    let result = false;
    if (this.state.formData.txtGSTNo.trim().length <= 0) {
      this.props.toastErrorMsg("Enter GSTNO", "txtGSTNo");
    } else if (this.state.formData.txtGSTNo.trim().length < 15) {
      this.props.toastErrorMsg("Enter 15 Digit GSTNO", "txtGSTNo");
    } else {
      result = true;
    }
    return result;
  };

  validateState = () => {
    let result = false;
    if (this.state.formData.cmbState.length > 0) {
      this.state.State.map((row) => {
        if (row.vac_state === this.state.formData.cmbState) {
          result = true;
        }
      });
    }
    return result;
  };

  validateTaxPayerType = () => {
    let result = false;
    if (this.state.formData.cmbGstRegtrationType.length > 0) {
      this.state.GstRegtrationType.map((row) => {
        if (row.Type === this.state.formData.cmbGstRegtrationType) {
          result = true;
        }
      });
    }
    return result;
  };

  trimFormData = (nextFunctionCall) => {
    // console.log("this.state.formData before SetSate", this.state.formData);
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["txtGSTPassword", "chkDefaultCompany"],
    });
    this.setState({ formData }, () => {
      // console.log("this.state.formData After SetSate", this.state.formData);
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateCompanyDetail = () => {
    let result = false;
    if (this.state.formData.txtCompanyName.length <= 0) {
      this.props.toastErrorMsg("Enter Trade Name", "txtCompanyName");
    } else if (this.state.formData.txtCity.length <= 0) {
      this.props.toastErrorMsg("Enter City", "txtCity");
    } else if (this.state.formData.cmbState.length <= 0) {
      this.props.toastErrorMsg("Select State", "cmbState");
    } else if (this.validateState() === false) {
      this.props.toastErrorMsg("Select valid State", "cmbState");
    } else if (this.state.formData.txtPinCode.length <= 0) {
      this.props.toastErrorMsg("Enter Pin Code", "txtPinCode");
    } else if (this.state.formData.txtPinCode.length != 6) {
      this.props.toastErrorMsg("Enter 6 digit Pin Code", "txtPinCode");
    } else if (
      this.state.formData.cmbGstRegtrationType.length > 0 &&
      this.validateTaxPayerType() === false
    ) {
      this.props.toastErrorMsg(
        "Select valid Tax Payer Type",
        "cmbGstRegtrationType",
      );
    } else if (
      this.state.formData.txtMobileNo.trim().length > 0 &&
      this.state.formData.txtMobileNo.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit Mobile no", "txtMobileNo");
    } else if (
      this.state.formData.txtEmailId.trim().length > 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmailId,
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email Address", "txtEmailId");
    } else if (
      /* else if (this.state.formData.cmbState.length <= 0) {
            this.props.toastErrorMsg('Enter State', 'cmbState')
        } */
      this.state.formData.txtGSTNo.trim().length > 0 &&
      this.state.formData.txtGSTNo.trim().length < 15
    ) {
      this.props.toastErrorMsg("Enter 15 Digit GSTNO", "txtGSTNo");
    } else if (
      this.state.formData.txtPANNo.trim().length > 0 &&
      this.state.formData.txtPANNo.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit PAN No.", "txtPANNo");
    } else if (
      this.state.formData.txtBankIFSCcode.trim().length > 0 &&
      this.state.formData.txtBankIFSCcode.trim().length < 11
    ) {
      this.props.toastErrorMsg("Enter 11 Digit IFSC code", "txtBankIFSCcode");
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "CompanyList",
        bolLoadState: true,
        bint_ci: localStorage.getItem("CI"),
      };

      fetchCompany(reqData)
        .then((res) => {
          // console.log(res.data.CompanyList.CompanyList);
          dataLoadStatus = true;
          let rows = res.data.CompanyList,
            rowsCount = rows.length,
            State = res.data.StateList,
            chkDefaultCompany = rowsCount > 1 ? false : true;
          // console.log(res.data.CompanyList.CompanyList);
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
            State,
            formData: {
              ...this.state.formData,
              chkDefaultCompany,
            },
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtGSTNo").focus();
  };

  clearInfo = () => {
    const bint_acid = "",
      txtCompanyName = "",
      txtGSTUserId = "",
      txtGSTPassword = "",
      txtMobileNo = "",
      txtEmailId = "",
      txtPersonName = "",
      txtAddress = "",
      txtPANNo = "",
      txtGSTNo = "",
      cmbGstRegtrationType = "",
      cmbState = "Gujarat",
      txtStateCode = "24",
      txtTermsAndConditionLine1 = "",
      txtTermsAndConditionLine2 = "",
      txtTermsAndConditionLine3 = "",
      txtTermsAndConditionLine4 = "",
      txtTermsAndConditionLine5 = "",
      txtBankName = "",
      txtBankBranchName = "",
      txtBankAcNo = "",
      txtBankIFSCcode = "",
      Logo = "",
      LogoLocation = "",
      LogoPath = "",
      LetterPadImg = "",
      LetterPadImgLocation = "",
      LetterPadImgPath = "",
      Signature = "",
      SignatureLocation = "",
      SignaturePath = "",
      Stamp = "",
      StampLocation = "",
      StampPath = "",
      txtPinCode = "",
      txtCity = "",
      txtEInvoiceID = "",
      txtEInvoicePassword = "",
      txtEWayBillUserID = "",
      txtEWayBillPassword = "",
      SignatureImg = "",
      SignatureImgLocation = "",
      SignatureImgPath = "",
      StampImg = "",
      StampImgLocation = "",
      StampImgPath = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_acid,
          txtCompanyName,
          txtGSTUserId,
          txtGSTPassword,
          txtMobileNo,
          txtEmailId,
          txtPersonName,
          txtAddress,
          txtPANNo,
          txtGSTNo,
          cmbGstRegtrationType,
          cmbState,
          txtStateCode,
          txtTermsAndConditionLine1,
          txtTermsAndConditionLine2,
          txtTermsAndConditionLine3,
          txtTermsAndConditionLine4,
          txtTermsAndConditionLine5,
          txtBankName,
          txtBankBranchName,
          txtBankAcNo,
          txtBankIFSCcode,
          Logo,
          LogoLocation,
          LogoPath,
          LetterPadImg,
          LetterPadImgLocation,
          LetterPadImgPath,
          Signature,
          SignatureLocation,
          SignaturePath,
          Stamp,
          StampLocation,
          StampPath,
          txtPinCode,
          txtCity,
          txtEInvoiceID,
          txtEInvoicePassword,
          txtEWayBillUserID,
          txtEWayBillPassword,
          SignatureImg,
          SignatureImgLocation,
          SignatureImgPath,
          StampImg,
          StampImgLocation,
          StampImgPath,
        },
      },
      () => {
        this.Logo.current.removeImage();
        this.LetterPadImg.current.removeImage();
        this.Signature.current.removeImage();
        this.Stamp.current.removeImage();
        document.getElementById("txtCompanyName").focus();
      },
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];

    searchColumns.push(
      { cType: "Lbl", id: "bint_acid" },
      { cType: "Lbl", id: "int_defaultcompany" },
      {
        cType: "CtTxt",
        id: "vac_company",
        label: "Trade Name",
        value: this.state.searchData.vac_company,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_gstno",
        label: "GST No",
        value: this.state.searchData.vac_gstno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "vac_gstuserid",
        label: "GST User ID",
        value: this.state.searchData.vac_gstuserid,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      { cType: "Lbl", id: "vac_gstpassword" },
      {
        cType: "Lbl",
        label: "Legal Name of Business",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_address",
        label: "Address",
        value: this.state.searchData.vac_address,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_state",
        items: this.state.State,
        label: "State",
        value: this.state.searchData.vac_state,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_statecode",
        label: "StateCode",
        value: this.state.searchData.vac_statecode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_pincode",
        label: "Pin Code",
        value: this.state.searchData.vac_pincode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_gstregtype",
        items: this.state.TaxPayerType,
        label: "Tax Payer Type",
        value: this.state.searchData.vac_gstregtype,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_panno",
        label: "PAN No",
        value: this.state.searchData.vac_panno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      { cType: "Lbl", id: "vac_bank" },
      { cType: "Lbl", id: "vac_branch" },
      { cType: "Lbl", id: "vac_acno" },
      { cType: "Lbl", id: "vac_ifsc" },
      {
        cType: "CtTxt",
        id: "vac_mobileno",
        label: "Mobile No",
        value: this.state.searchData.vac_mobileno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_email",
        label: "Email Id",
        value: this.state.searchData.vac_email,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "int_defaultcompany",
        label: "Defaut Company",
        value: this.state.searchData.int_defaultcompany,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_tc1",
        value: this.state.searchData.vac_tc1,
        label: "Terms & Conditions 1",
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_tc2",
        value: this.state.searchData.vac_tc2,
        label: "Terms & Conditions 2",
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_tc3",
        value: this.state.searchData.vac_tc3,
        label: "Terms & Conditions 3",
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_tc4",
        value: this.state.searchData.vac_tc4,
        label: "Terms & Conditions 4",
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_tc5",
        value: this.state.searchData.vac_tc5,
        label: "Terms & Conditions 5",
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_einvoiceuserid",
        label: "E-Invoice User ID",
        value: this.state.searchData.vac_einvoiceuserid,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_einvoicepassword",
        label: "E-Invoice Password",
        value: this.state.searchData.vac_einvoicepassword,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_ewaybilluserid",
        label: "E-Way Bill User ID",
        value: this.state.searchData.vac_ewaybilluserid,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_ewaybillpassword",
        label: "E-Way Bill Password",
        value: this.state.searchData.vac_ewaybillpassword,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      // {
      //   cType: "CtTxt",
      //   id: "vac_tc5",
      //   value: this.state.searchData.vac_tc5,
      //   label: "Terms&Conditions5",
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "100",
      //   maxLength: "10",
      // }
    );
    this.setState({ searchColumns });
  };

  OnGstInfoClick = () => {
    if (this.validateGstInfo()) {
      this.props.toastErrorMsg("Development Remain..");
    }
  };

  getAcYear = () => {
    if (localStorage.getItem("ACY")) {
      return localStorage.getItem("ACY");
    } else {
    }
  };

  SaveCompanyDetail = () => {
    if (this.validateCompanyDetail()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveCompany",
          bint_ci:
            this.state.formData.bint_acid == 0
              ? localStorage.getItem("CI")
              : this.state.formData.bint_ci,
          bint_acid: this.state.formData.bint_acid,
          vac_gstno: this.state.formData.txtGSTNo.toUpperCase(),
          vac_gstuserid: this.state.formData.txtGSTUserId,
          vac_gstpassword: this.state.formData.txtGSTPassword,
          vac_company: this.state.formData.txtCompanyName,
          vac_personname: this.state.formData.txtPersonName,
          vac_address: this.state.formData.txtAddress,
          vac_state: this.state.formData.cmbState,
          vac_statecode: this.state.formData.txtStateCode,
          vac_gstregtype: this.state.formData.cmbGstRegtrationType,
          vac_panno: this.state.formData.txtPANNo,
          int_defaultcompany: this.state.formData.chkDefaultCompany ? 1 : 0,
          vac_mobileno: this.state.formData.txtMobileNo,
          vac_email: this.state.formData.txtEmailId,
          vac_tc1: this.state.formData.txtTermsAndConditionLine1,
          vac_tc2: this.state.formData.txtTermsAndConditionLine2,
          vac_tc3: this.state.formData.txtTermsAndConditionLine3,
          vac_tc4: this.state.formData.txtTermsAndConditionLine4,
          vac_tc5: this.state.formData.txtTermsAndConditionLine5,
          bint_acyear: localStorage.getItem("ACY"),
          // vac_kidname: this.state.formData.Logo,
          // vac_kidname: this.state.formData.LetterPadImg,
          vac_bankname: this.state.formData.txtBankName,
          vac_bankbranchname: this.state.formData.txtBankBranchName,
          vac_bankacno: this.state.formData.txtBankAcNo,
          vac_bankifsccode: this.state.formData.txtBankIFSCcode,
          vac_pincode: this.state.formData.txtPinCode,
          vac_city: this.state.formData.txtCity,
          vac_einvoiceuserid: this.state.formData.txtEInvoiceID,
          vac_einvoicepassword: this.state.formData.txtEInvoicePassword,
          vac_ewaybilluserid: this.state.formData.txtEWayBillUserID,
          vac_ewaybillpassword: this.state.formData.txtEWayBillPassword,
        };
        fetchCompany(reqData)
          .then((res) => {
            // console.log(res.data);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              if (
                this.state.formData.bint_acid == localStorage.getItem("acid")
              ) {
                localStorage.setItem(
                  "CompanyName",
                  this.state.formData.txtCompanyName,
                );
              }
              if (
                localStorage.getItem("CompanyName") &&
                this.state.rowsCount <= 1 &&
                (localStorage.getItem("CompanyName") == null ||
                  localStorage.getItem("CompanyName") == "")
              ) {
                localStorage.setItem(
                  "CompanyName",
                  this.state.formData.txtCompanyName,
                );
              }
              this.getInfo();
              this.clearInfo(true);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveCompanyDetail.", error);
          });
      });
    }
  };

  onDeleteClick = () => {
    if (
      this.props.userPrivilege.AdminType !== "Admin" &&
      this.props.userPrivilege.AdminType !== "SA"
    ) {
      this.props.toastErrorMsg("You are not authorized to delete.");
      return;
    }
    const Company = this.state.formData.txtCompanyName;
    if (Company !== "") {
      let Msg = () => {
        return (
          <>
            <p>Do you want to Delete Company : {Company}</p>
            <p
              style={{
                color: "red",
                fontSize: "17px",
                fontWeight: "bold",
                marginTop: "0px",
                paddingTop: "0px",
              }}
            >
              Note:- This deletion process will remove all data of the Company,
              and this can not be undo at any conditions
            </p>
          </>
        );
      };
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDelete="Delete"
            labelDisagree="Cancel"
            DisagreeBtnVariant="outlined"
            // alertTitle={Msg()}
            alertNote="This deletion process will remove all data of the Company, and this can not be undo at any conditions"
            alertTitle={`Do you want to Delete Company : ${Company}`}
            handleOnClickYes={() => {
              this.DeleteCompanyDetail(this.state.formData.bint_acid);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastMsg("error", "No records to Delete");
    }
  };
  closeVerifyDialog = () => {
    this.setState({
      showVerifyDialog: false,
      verifyingAcid: null,
      formData: {
        ...this.state.formData,
        txtUserId: "",
        txtPassword: "",
      },
    });
  };

  openVerifyUserARD = (bint_acid) => {
    this.setState({
      showVerifyDialog: true,
      verifyingAcid: bint_acid,
      formData: {
        ...this.state.formData,
        txtUserId: "",
        txtPassword: "",
      },
    });
  };
  // openVerifyUserARD = (bint_acid) => {
  //   this.setState({ ARD: null }, () => {
  //     const ARD = (
  //       <AlertResponsiveDialog
  //         labelAgree="Verify"
  //         labelDisagree="Cancel"
  //         handleOnClickYes={() => this.handleVerifyAndDelete(bint_acid)}
  //         defaultOpenDialog={true}
  //         alertMessage={
  //           <>
  //             <CtTxt
  //               id="txtUserId"
  //               label="User ID"
  //               variant="outlined"
  //               handleOnChange={this.handleOnChange}
  //               value={this.state.formData.txtUserId}
  //               fullWidth={true}
  //               maxLength="50"
  //             />
  //             <CtTxtPWD
  //               id="txtPassword"
  //               label="Password"
  //               variant="outlined"
  //               handleOnChange={this.handleOnChange}
  //               value={this.state.formData.txtPassword}
  //               type="password"
  //               fullWidth={true}
  //               formcontrolStyle={{ marginTop: "20px" }}
  //               maxLength="50"
  //             />
  //           </>
  //         }
  //       />
  //     );

  //     this.setState({ ARD });
  //   });
  // };
  validuser = async () => {
    const { txtUserId, txtPassword } = this.state.formData;

    // if (!txtUserId || txtUserId.trim().length === 0) {
    //   this.props.toastErrorMsg("Enter User ID", "txtUserId");
    //   return false;
    // }
    if (!txtPassword || txtPassword.trim().length === 0) {
      this.props.toastErrorMsg("Enter Password", "txtPassword");
      return false;
    }

    const reqData = {
      Op: "VerifyCompanysUserIsAdminOrSA",
      bint_acid: this.state.verifyingAcid,
      vac_userid: localStorage.getItem("logInID"),
      vac_password: txtPassword,
    };

    try {
      this.props.notifyProcessing();
      const res = await fetchCompany(reqData);
      if (res.data.VerifyCompanysUserIsAdmin_OR_SA === true) {
        this.props.closeUpdateProcessing();
        return true;
      } else {
        this.props.updateProcessing("error", "Invalid credentials");
        return false;
      }
    } catch (error) {
      this.props.updateProcessing("error", "Verification failed " + error);
      return false;
    }
  };
  handleVerifyAndDelete = async () => {
    const isValid = await this.validuser();

    if (isValid) {
      const bint_acid = this.state.verifyingAcid;
      this.setState({ showVerifyDialog: false, verifyingAcid: null }, () => {
        this.deleteCompanyAfterVerify(bint_acid);
      });
      return true;
    } else {
      return false;
    }
  };
  deleteCompanyAfterVerify = (bint_acid) => {
    this.props.notifyProcessing();

    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteCompany",
        bint_acid: bint_acid,
        bint_acyear: localStorage.getItem("ACY"),
      };

      fetchCompany(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);

          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in delete. " + error,
          );
        });
    });
  };

  DeleteCompanyDetail = (bint_acid) => {
    this.openVerifyUserARD(bint_acid);
  };

  openARDGstInfo = () => {
    let vac_gstin = this.state.formData.txtGSTNo;
    if (this.validateGstInfo()) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage=<GstInfo
              vac_gstin={vac_gstin.toUpperCase()}
              update={this.update}
            />
            defaultOpenDialog={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  update = (
    legalNameOfBusiness,
    tradeName,
    address,
    gstno,
    state,
    statecode,
  ) => {
    this.setState({
      formData: {
        ...this.state.formData,
        txtPersonName: legalNameOfBusiness,
        txtCompanyName: tradeName,
        txtAddress: address.split(", ").slice(0, -3).join(", "),
        txtGSTNO: gstno,
        cmbState: state,
        txtStateCode: statecode,
        txtPANNo: gstno.substring(2, 12),
        txtPinCode: address.split(" ").pop(),
        txtCity: address.split(", ")[address.split(", ").indexOf(state) - 1],
      },
      ARD: null,
    });
  };
  //#endregion function

  render() {
    // console.log(
    //   "this.state.formData.LetterPadImg",
    //   this.state.formData.LetterPadImg
    // );
    // console.log(
    //   "this.state.formData.LetterPadImgLocation",
    //   this.state.formData.LetterPadImgLocation
    // );
    // console.log(
    //   "this.state.formData.LetterPadImgPath",
    //   this.state.formData.LetterPadImgPath
    // );

    console.log(
      "this.props.userPrivilege.AdminType",
      this.props.userPrivilege.AdminType,
    );

    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    let fixLogoFileName = "Logo_" + this.state.formData.bint_acid,
      fixLetterPadFileName = "LetterPadImg_" + this.state.formData.bint_acid,
      fixSignatureFileName = "Signature_" + this.state.formData.bint_acid,
      fixStampFileName = "Stamp_" + this.state.formData.bint_acid;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />

        {this.state.showVerifyDialog && (
          <AlertResponsiveDialog
            labelAgree="Verify"
            labelDisagree="Cancel"
            handleOnClickYes={this.handleVerifyAndDelete}
            handleOnClickNo={this.closeVerifyDialog}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
            alertMessage={
              <>
                {/* <CtTxt
                  id="txtUserId"
                  label="User ID"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtUserId || ""}
                  fullWidth
                  maxLength={50}
                /> */}
                <Typography>
                  <span style={{ fontSize: "13px" }}>User ID </span>
                </Typography>
                <Typography>
                  <strong>{localStorage.getItem("logInID")}</strong>
                </Typography>

                <CtTxtPWD
                  id="txtPassword"
                  label="Password"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtPassword || ""}
                  type="password"
                  fullWidth
                  formcontrolStyle={{ marginTop: "20px" }}
                  maxLength={50}
                />
              </>
            }
          />
        )}
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Company</b>
          </label>
        </Grid> */}
        <Grid container direction="row" spacing={0}>
          <Grid item lg={3} md={12} sm={12}>
            <Grid
              container
              justifyContent="center"
              aleignItems="center"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item lg={12} xs={12} sm={6} md={3}>
                <ImageUploadIcon
                  id="imgLetterPad"
                  ref={this.LetterPadImg}
                  default={PH_LETTERPADIMG}
                  curImageName={this.state.formData.LetterPadImg}
                  curImageLocation={this.state.formData.LetterPadImgLocation}
                  curImageFullPath={this.state.formData.LetterPadImgPath}
                  onCurImageChange={this.onLetterPadChange}
                  notResetImageOnUpload={true}
                  fixFileName={fixLetterPadFileName}
                  uploadLocation="LetterPadImg"
                  showDeleteIcon={true}
                  maxSizeInKB={2000}
                  //changeImagePreValidation={this.validateProfiledata}
                  displayFileUploadedMsg={false}
                  removeImage={this.removeLetterHead}
                  toastMsg={this.props.toastMsg}
                  toastErrorMsg={this.props.toastErrorMsg}
                  disableAction={
                    !(
                      this.state.formData.bint_acid &&
                      this.state.formData.bint_acid > 0
                    )
                  }
                />
              </Grid>
              <Grid item lg={12} xs={12} sm={6} md={3}>
                <ImageUploadIcon
                  id="Logo"
                  ref={this.Logo}
                  default={PH_LOGO}
                  curImageName={this.state.formData.Logo}
                  curImageLocation={this.state.formData.LogoLocation}
                  curImageFullPath={this.state.formData.LogoPath}
                  onCurImageChange={this.onLogoChange}
                  notResetImageOnUpload={true}
                  fixFileName={fixLogoFileName}
                  uploadLocation="Logo"
                  showDeleteIcon={true}
                  // maxSizeInKB={"auto"}
                  maxSizeInKB={2000}
                  //changeImagePreValidation={this.validateProfiledata}
                  displayFileUploadedMsg={false}
                  removeImage={this.removeLogo}
                  toastMsg={this.props.toastMsg}
                  toastErrorMsg={this.props.toastErrorMsg}
                  disableAction={
                    !(
                      this.state.formData.bint_acid &&
                      this.state.formData.bint_acid > 0
                    )
                  }
                />
              </Grid>
              <Grid item lg={12} xs={12} sm={6} md={3}>
                <ImageUploadIcon
                  id="Signature"
                  ref={this.Signature}
                  default={PH_Signature}
                  curImageName={this.state.formData.SignatureImg}
                  curImageLocation={this.state.formData.SignatureImgLocation}
                  curImageFullPath={this.state.formData.SignatureImgPath}
                  onCurImageChange={this.onSignatureChange}
                  notResetImageOnUpload={true}
                  fixFileName={fixSignatureFileName}
                  uploadLocation="Signature"
                  showDeleteIcon={true}
                  // maxSizeInKB={"auto"}
                  maxSizeInKB={2000}
                  //changeImagePreValidation={this.validateProfiledata}
                  displayFileUploadedMsg={false}
                  removeImage={this.removeSignature}
                  toastMsg={this.props.toastMsg}
                  toastErrorMsg={this.props.toastErrorMsg}
                  disableAction={
                    !(
                      this.state.formData.bint_acid &&
                      this.state.formData.bint_acid > 0
                    )
                  }
                />
              </Grid>
              <Grid item lg={12} xs={12} sm={6} md={3}>
                <ImageUploadIcon
                  id="Stamp"
                  ref={this.Stamp}
                  default={PH_Stamp}
                  curImageName={this.state.formData.StampImg}
                  curImageLocation={this.state.formData.StampImgLocation}
                  curImageFullPath={this.state.formData.StampImgPath}
                  onCurImageChange={this.onStampChange}
                  notResetImageOnUpload={true}
                  fixFileName={fixStampFileName}
                  uploadLocation="Stamp"
                  showDeleteIcon={true}
                  // maxSizeInKB={"auto"}
                  maxSizeInKB={2000}
                  //changeImagePreValidation={this.validateProfiledata}
                  displayFileUploadedMsg={false}
                  removeImage={this.removeStamp}
                  toastMsg={this.props.toastMsg}
                  toastErrorMsg={this.props.toastErrorMsg}
                  disableAction={
                    !(
                      this.state.formData.bint_acid &&
                      this.state.formData.bint_acid > 0
                    )
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={9} md={12} sm={12}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              {/* <Grid item>
                <CtTxt
                  id="txtCompanyCode"
                  label="Company Code"
                  // value={this.state.formData.txtCompanyName}
                  // handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                />
              </Grid> */}
              <Grid item>
                <CtTxt
                  id="txtGSTNo"
                  value={this.state.formData.txtGSTNo}
                  label="GST No"
                  handleOnChange={this.handleOnChange}
                  width={185}
                  maxLength={15}
                  isUpperCase={true}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtGSTUserId"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtGSTUserId"
                  value={this.state.formData.txtGSTUserId}
                  label="GST User ID"
                  handleOnChange={this.handleOnChange}
                  width={185}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtGSTPassword"
                />
              </Grid>
              <Grid item>
                <CtTextFieldPWD
                  id="txtGSTPassword"
                  value={this.state.formData.txtGSTPassword}
                  // type="password"
                  label="GST Password"
                  handleOnChange={this.handleOnChange}
                  width={185}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtCompanyName"
                  autoFillPassword={false}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  variant="outlined"
                  label="Get GST Info."
                  onClick={this.openARDGstInfo}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtTxt
                  id="txtCompanyName"
                  value={this.state.formData.txtCompanyName}
                  label="Trade Name*"
                  handleOnChange={this.handleOnChange}
                  width={286}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPersonName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPersonName"
                  value={this.state.formData.txtPersonName}
                  handleOnChange={this.handleOnChange}
                  label="Legal Name of Business"
                  width={286}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAddress"
                />
              </Grid>
              <Grid item xs={10} sm={7.1}>
                <CtMultiLineText
                  id="txtAddress"
                  label="Address"
                  value={this.state.formData.txtAddress}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbState"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtCity"
                  label="City*"
                  value={this.state.formData.txtCity}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbState"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbState"
                  label="State*"
                  items={this.state.State}
                  value={this.state.formData.cmbState}
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={50}
                  colID="vac_state"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPinCode"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtStateCode"
                  label="State Code*"
                  disabled={true}
                  value={this.state.formData.txtStateCode}
                  handleOnChange={this.handleOnChange}
                  width={80}
                  maxLength={5}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbGstRegtrationType"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtPinCode"
                  label="Pin Code*"
                  value={this.state.formData.txtPinCode}
                  handleOnChange={this.handleOnChange}
                  width={80}
                  maxLength={6}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbGstRegtrationType"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbGstRegtrationType"
                  label="Tax Payer Type"
                  items={this.state.GstRegtrationType}
                  value={this.state.formData.cmbGstRegtrationType}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={30}
                  colID="Type"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPANNo"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPANNo"
                  value={this.state.formData.txtPANNo}
                  label="PAN No"
                  isUpperCase={true}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtBankName"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtTxt
                  id="txtBankName"
                  value={this.state.formData.txtBankName}
                  label="Bank Name"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtBankBranchName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBankBranchName"
                  value={this.state.formData.txtBankBranchName}
                  label="Branch Name"
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtBankAcNo"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBankAcNo"
                  value={this.state.formData.txtBankAcNo}
                  label="Ac No"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtBankIFSCcode"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBankIFSCcode"
                  value={this.state.formData.txtBankIFSCcode}
                  label="IFSC"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={11}
                  isUpperCase={true}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileNo"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo"
                  value={this.state.formData.txtMobileNo}
                  label="Mobile No"
                  handleOnChange={this.handleOnChange}
                  width={180}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmailId"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmailId"
                  value={this.state.formData.txtEmailId}
                  label="Email Id"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTermsAndConditionLine1"
                />
              </Grid>
              <Grid item>
                <CtCheckBox
                  id="chkDefaultCompany"
                  name="chkDefaultCompany"
                  label="Default Company"
                  checked={this.state.formData.chkDefaultCompany}
                  handleCheckChange={this.handleOnChkChange}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="txtTermsAndConditionLine1"
                ></CtCheckBox>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtTermsAndConditionLine1"
                  label="Terms & Condition Line 1"
                  value={this.state.formData.txtTermsAndConditionLine1}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTermsAndConditionLine2"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtTermsAndConditionLine2"
                  label="Terms & Condition Line 2"
                  value={this.state.formData.txtTermsAndConditionLine2}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTermsAndConditionLine3"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtTermsAndConditionLine3"
                  label="Terms & Condition Line 3"
                  value={this.state.formData.txtTermsAndConditionLine3}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTermsAndConditionLine4"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtTermsAndConditionLine4"
                  label="Terms & Condition Line 4"
                  value={this.state.formData.txtTermsAndConditionLine4}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtTermsAndConditionLine5"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtTermsAndConditionLine5"
                  label="Terms & Condition Line 5"
                  value={this.state.formData.txtTermsAndConditionLine5}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEInvoiceID"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtTxt
                  id="txtEInvoiceID"
                  value={this.state.formData.txtEInvoiceID}
                  label="E-Invoice User ID"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEInvoicePassword"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEInvoicePassword"
                  value={this.state.formData.txtEInvoicePassword}
                  label="E-Invoice Password"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEWayBillUserID"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtTxt
                  id="txtEWayBillUserID"
                  value={this.state.formData.txtEWayBillUserID}
                  label="E-Way Bill User ID"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEWayBillPassword"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEWayBillPassword"
                  value={this.state.formData.txtEWayBillPassword}
                  label="E-Way Bill Password"
                  handleOnChange={this.handleOnChange}
                  width={190}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveCompanyDetail();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant="outlined"
                />
              </Grid>
              {(this.props.userPrivilege.AdminType == "Admin" ||
                this.props.userPrivilege.AdminType == "SA") && (
                <Grid item>
                  <CtBtn label="Delete" onClick={this.onDeleteClick} />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <Grid container direction="row" justifyContent="center" alignItems="center"> */}
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}

        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("Customer")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            this.props.userPrivilege.AdminType == "Admin" ||
            this.props.userPrivilege.AdminType == "SA"
              ? {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                }
              : "",
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={[
            "int_defaultcompany",
            "vac_gstpassword",
            "bint_acid",
            "bint_salessrno",
            "vac_image",
            "vac_logo",
            "vac_letterheadname",
            "vac_logoname",
            "vac_signatureimagename",
            "vac_signatureimage",
            "vac_stamp",
            "vac_stampname",
            "bint_ci",
          ]}
          density={"compact"}
        />
        <br />
        {/* </Grid> */}
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(CompanyMaster)));
